import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useState } from 'react';

export default function ButtonSizes({ onSelectPosition }) {
  const [clickedButtonIndex, setClickedButtonIndex] = useState(0);
  const positionsFilters = ['ALL', 'QB', 'RB', 'WR', 'TE', 'K', 'DEF'];

  const handleButtonClick = (index, position) => {
    setClickedButtonIndex(index);
    if (position === 'ALL') {
      onSelectPosition(null); //Render all players
    } 
    // else if (position === 'DEF') {
    //   // Filter players other than QB, RB, WR, TE or K
    //   onSelectPosition(['QB', 'RB', 'WR', 'TE', 'K']);
    // } 
    else {
      onSelectPosition(position); // Render players of currently selected position
    }
  };

  return (
    <>
      <Grid container spacing={0} alignItems="center" justifyContent="center" p={3}>
        {positionsFilters.map((position, index) => (
          <Grid key={index} p={0.2}>
            <Button
              key={index}
              variant="contained"
              color={clickedButtonIndex === index ? 'info' : 'inherit'}
              onClick={() => handleButtonClick(index, position)}
              style={{ borderRadius: '5px', padding: '0px 2px', minWidth: '20px', width: '40px' }}
            >
              {position}
            </Button>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
